import React from 'react'
import Dashboard from "./Dashboard"
import EnsureLoggedIn from "../../shared/EnsureLoggedIn"
import {connect} from "react-redux"
import {getLocalData} from "../../../services/StorageServices"

function DashboardContainer(props) {
    const rolesLocal = getLocalData('roles')
    const logoTenant = getLocalData('logoTenant')
    const {roles} = props

    return (
        <EnsureLoggedIn>
            {
                ((roles && roles?.length > 0) || (rolesLocal && rolesLocal?.length > 0)) &&
                <Dashboard {...props} logoTenant={logoTenant} rolesLocal={rolesLocal} basePath="/crm"/>
            }
        </EnsureLoggedIn>
    )
}

const mapStateToProps = state => {
    return {
        roles: state.rolesReducer.roles,
        logoTenant: state.rolesReducer.logoTenant
    };
};

export default connect(mapStateToProps)(DashboardContainer)
